/**
 * LanguageToggle コンポーネント
 *
 * 言語切替ボタン。日本語/Englishを切り替える。
 * Zustand language-storeと連携し、選択された言語を永続化。
 *
 */

import { Button } from '@/components/atoms/Button';
import { useLanguageStore } from '@/stores/language-store';
import { useI18n } from '@/i18n/useI18n';

/**
 * LanguageToggle コンポーネント
 *
 * 使用例:
 * ```tsx
 * <LanguageToggle />
 * ```
 */
export function LanguageToggle() {
  const { t } = useI18n();
  const { language, setLanguage } = useLanguageStore();

  const handleLanguageToggle = () => {
    setLanguage(language === 'ja' ? 'en' : 'ja');
  };

  return (
    <Button
      variant="outline"
      size="sm"
      onClick={handleLanguageToggle}
      aria-label={t('common.languageToggle')}
      className="min-w-[4rem]"
    >
      {language === 'ja'
        ? t('common.languageEnglish')
        : t('common.languageJapanese')}
    </Button>
  );
}
